import { ResearchAuthGuard } from "research.oidc.angular";
import { RequestHeaderComponent } from "./request-header/request-header.component";
import { RequestOptionsResolver } from "../shared/resolvers/request-options-resolver";
import { RequestDetailsResolver } from "../shared/resolvers/request-details.resolver";
import { RequestDesignResolver } from "../shared/resolvers/request-design.resolver";
import { ExperimentDetailsFormPageComponent } from "./experiment-details/experiment-details-form-page/experiment-details-form-page.component";
import { ExperimentDesignFormPageComponent } from "./experiment-design/experiment-design-form-page/experiment-design-form-page.component";
import { UserRoleGuard } from "./user-role-guard";
import { UserRoles } from "../shared/services/current-user.service";
import { CurrentUserResolver } from "../shared/resolvers/current-user.resolver";
import { SeedRequestsResolver } from "../shared/resolvers/seed-requests-resolver";
var ɵ0 = {
    allowedRoles: UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator,
    message: 'You are not authorized to create requests'
}, ɵ1 = {
    allowedRoles: UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator,
    message: 'You are not authorized to edit requests'
}, ɵ2 = {
    allowedRoles: UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator,
    message: 'You are not authorized to edit requests'
};
var routes = [
    {
        path: "requests/create",
        component: RequestHeaderComponent,
        canActivate: [ResearchAuthGuard, UserRoleGuard],
        data: ɵ0,
        resolve: {
            requestOptions: RequestOptionsResolver,
            currentUser: CurrentUserResolver
        }
    },
    {
        path: 'requests/edit/:id/details',
        component: ExperimentDetailsFormPageComponent,
        canActivate: [ResearchAuthGuard, UserRoleGuard],
        data: ɵ1,
        resolve: {
            requestOptions: RequestOptionsResolver,
            requestDetails: RequestDetailsResolver,
            requestDesign: RequestDesignResolver,
            currentUser: CurrentUserResolver
        }
    },
    {
        path: 'requests/edit/:id/design',
        component: ExperimentDesignFormPageComponent,
        canActivate: [ResearchAuthGuard, UserRoleGuard],
        data: ɵ2,
        resolve: {
            requestOptions: RequestOptionsResolver,
            requestDetails: RequestDetailsResolver,
            requestDesign: RequestDesignResolver,
            seedRequests: SeedRequestsResolver
        }
    },
    {
        path: 'requests/edit/:id',
        redirectTo: 'requests/edit/:id/details'
    }
];
var RequestCreationRoutingModule = /** @class */ (function () {
    function RequestCreationRoutingModule() {
    }
    return RequestCreationRoutingModule;
}());
export { RequestCreationRoutingModule };
export { ɵ0, ɵ1, ɵ2 };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/request-creation-routing.module.ts.pre-build-optimizer.js